// extracted by mini-css-extract-plugin
export default {"fourth":"Fourth_fourth__I5Gk7"};